import React, { Component } from 'react';
import ButtonMaterial from '../../../../materials/ButtonMaterial';

interface IProps {
  handleChangeAndPopUpModal: any;
}

export default class ButtonEditServerVoipComponent extends Component<IProps> {
  render() {
    return (
      <div>
        <ButtonMaterial
          disabled={''}
          handleSubmit={this.props.handleChangeAndPopUpModal}
          teksButton={''}
          size={''}
          shape={''}
          className={''}
          type={'primary'}
          icon={'edit'}
          style={{
            borderRadius: '8px',
            color: '#fafafa',
            paddingBottom: '3px',
            background: '#FCC642',
            borderColor: '#FCC642',
          }}
        />
      </div>
    );
  }
}
